import { render, staticRenderFns } from "./MarkAsModal.vue?vue&type=template&id=42d67cd2&scoped=true&"
import script from "./MarkAsModal.vue?vue&type=script&lang=js&"
export * from "./MarkAsModal.vue?vue&type=script&lang=js&"
import style0 from "./MarkAsModal.vue?vue&type=style&index=0&id=42d67cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d67cd2",
  null
  
)

export default component.exports